import type { FaireProductEntity } from "../../entity_types/product";

export const p_gy4tzqwv6t: FaireProductEntity = {
  token: "p_gy4tzqwv6t",
  type: "product",
  name: "Bamboo pajama Checkered 2 pieces set",
  brandToken: "b_gm63vb47za",
  brandName: "Little Organic Co",
  imageUrl:
    "https://cdn.faire.com/fastly/0420690849992ab1c8f18a5ee6ad24f092fe29158ddb00f256d6315303942331.png",
  galleryImageUrls: [],
  priceDollars: 25,
  description:
    "Convertible Bamboo Pajamas / Rompers – Comfort Meets Innovation\n\nDiscover the perfect blend of comfort and functionality with our Convertible Bamboo Pajamas / Rompers. Made from a premium blend of 94% bamboo and 6% spandex, these rompers deliver exceptional softness, gentle stretch, and naturally hypoallergenic protection, making them ideal for sensitive baby skin.\n\nDesigned with parents in mind, the 2-way zipper allows for quick, fuss-free changes, day or night. The fold-over cuffs and built-in footies provide added warmth and protection—no more lost socks!\n\nAvailable from newborn to 24 months, these rompers are crafted to grow with your little one, offering long-lasting comfort and style.\n\nWhy You'll Love Them:\n• Ultra-soft, breathable 94% bamboo fabric\n• Hypoallergenic + perfect for sensitive skin\n• 2-way zipper for effortless diaper changes\n• Fold-over cuffs and footie design for versatility\n• Stretchy, durable fit for babies 0–24 months\n\nExperience comfort, convenience, and timeless style—perfect for every stage of your baby’s day.\n\n\n\nPre-Order Arriving Mid December \n\nyour order will be shipped as soon as they arrive\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:44.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
